import validateColo from "./validateColo";
import validateLung from "./validateLung";
import validateMesothelioma from "./validateMesothelioma";
import validateOesophagus from "./ValidateOesophagus";
import validatePancreas from "./validatePancreas";
import validateStomach from "./validateStomach";
import validateLiverGb from "./validateLiverGb";
import validateBreast from "./validateBreast";
import validateOvarian from "./validateOvarian";
import validateEndometrial from "./validateEndometrial";
import validateCervical from "./validateCervical.js";
import validateVulval from "./validateVulval.js";
import validateVaginal from "./validateVaginal.js";
import validateProstate from "./validateProstate.js";
import validateBladder from "./validateBladder.js";
import validateRenal from "./validateRenal";
import validateTesticular from "./validateTesticular";
import validatePenile from "./validatePenile";
import validateMelanoma from "./validateMelanoma";
import validateSquamous from "./validateSquamous";
import validateBasal from "./validateBasal";
import validatelaryngeal from "./validateLaryngeal";
import validateOral from "./validateOral"; 
import validateThyroid from "./validateThyroid";
import validateCns from "./ValidateCns";
import validateLeukaemia from "./validateLeukaemia,";
import validateMyeloma from "./validateMyeloma";
import validateNonHodgekins from "./validateNonHodgkins";
import validateHodgekins from "./validateHodgkins";
import validateBoneSarcoma from "./validateBoneSarcoma";
import validateSoftTissueSarcoma from "./validateSoftTissueSarcoma";
import validateNeuroblastoma from "./validateNeuroblastoma";
import validateRetinoblastoma from "./validateRetinoblastoma";
import validateWilms from "./validateWilms";
import validateNonSpecific from "./validateNonSpecific";
import validateChildConcern from "./validateChildConcern";

const validatorIndex=
{
    
colorectal:{
path:"colorectal",  
symptoms:[
    "weightLoss",
    "abdoPain",
    "abdoMass",
    "rectalBleeding", 
    "anaemia", 
    "rectalMass",
    "idAnaemia", 
    "cobh", 
    "fit"],
validator:validateColo,
displayAs:"Colorectal",
requirements:["FIT tests", "Stool culture", "FBC", "Ferritin", "Iron Studies", "U&E", "Thyroid function", "LFT", "Coeliac screen", "CRP", "ESR", "Calprotectin"],
specialty:["colorectal surgery", "gastroenterology"],
},

lung:{
path:"lung",  
symptoms:[
    "weightLoss"
    ,"fatigue"
    ,"appetiteLoss"
    ,"thrombocytosis"
    ,"smoker"
    ,"cxrLung"
    ,"haemoptysis"
    ,"cough"
    ,"sob"
    ,"chestPain"
    ,"fingerClubbing"
    ,"neckNodes"
    ,"chestSignsLung"
    ,"chestInfection"],
validator:validateLung,
displayAs:"Lung",
requirements:[ "Chest X Ray"],
specialty:["respiratory"],
},

mesothelioma:{
path:"mesothelioma",  
symptoms:[
    "weightLoss"
    ,"fatigue"
    ,"appetiteLoss"
    ,"smoker"
    ,"asbestos"
    ,"cxrPleural"
    ,"haemoptysis"
    ,"cough"
    ,"sob"
    ,"chestPain"
    ,"fingerClubbing"
    ,"chestSignsPleural"
   ],
validator:validateMesothelioma,
displayAs:"Mesothelioma",
requirements:[ "Chest X Ray"],
specialty:["respiratory"]
},

oesophagus:{
path:"oesophagus",
symptoms:[
    "weightLoss",
    "nausea",
    "anaemia",
    "idAnaemia",
    "thrombocytosis",
    "upperAbdoPain",
    "dysphagia",
    "reflux",
    "dyspepsia",
    "vomiting",
    "haematemesis"
    ],

validator:validateOesophagus,
displayAs:"Oesophageal Carcinoma",
requirements:["FBC", "CRP", "LFT", "U&E", "Ferritin", "Iron Studies","INR", "HbA1c" ],
specialty:["upper GI surgery", "gastroenterology"]
},

pancreas:{
path: "pancreas",
symptoms: [
    "weightLoss",
    "nausea",
    "jaundice",
    "diabetes",
    "elevatedGlucose",
    "upperAbdoPain",
    "abdoPain",
    "backPain",
    "vomiting",
    "cobh"],
validator: validatePancreas,
displayAs: "Pancreatic Cancer",
requirements:["FBC", "CRP", "LFT", "U&E", "Ferritin", "Iron Studies","INR", "HbA1c" ],
specialty:["hepatobiliary surgery", "gastroenterology", "endocrinology"]
},

stomach:{
path:"stomach",
symptoms:[
    "upperAbdoPain",
    "upperAbdoMass",
    "weightLoss",
    "nausea",
    "anaemia",
    "idAnaemia",
    "thrombocytosis",
    "upperAbdoPain",
    "dysphagia",
    "reflux",
    "dyspepsia",
    "vomiting",
    "haematemesis"
    ],
validator:validateStomach,
displayAs:"Stomach Cancer",
requirements:["FBC", "CRP", "LFT", "U&E", "Ferritin", "Iron Studies","INR", "HbA1c" ],
specialty:["upper GI surgery", "gastroenterology"]
},


liverGb:{
path:"liverGb",
symptoms:[
    "LiverGbMass"
    ],
validator:validateLiverGb,
displayAs:"Liver or Gall Bladder Cancer",
requirements:["FBC", "CRP", "LFT", "U&E", "Ferritin", "Iron Studies","INR", "HbA1c" ],
specialty:["heptobiliary surgery", "gastroenterology"]
},

breast:{
path:"breast",
symptoms:[
    "breastLump",
    "nippleDischarge",
    "nippleRetraction",
    "breastOther",
    "breastSkinChanges",
    "axillaLump",
    ],
validator:validateBreast,
displayAs:"Breast",
requirements:[],
specialty:["breast surgery"]
},

ovarian:{
path:"ovarian",
symptoms:[
    "abdoMass",
    "pelvicMass",
    "weightLoss",
    "fatigue",
    "appetiteLoss",
    "earlySatiety",
    "abdoPain",
    "pelvicPain",
    "distension",
    "ascites",
    "cobh",
    "urinaryFrequency",
    "ca125",
    "imagingOvarian"
        ],
    validator:validateOvarian,
    displayAs:"Ovarian Cancer",
    requirements:[],
    specialty:["gynaecology"]
    },

endometrial:{
path:"endometrial",
symptoms:[
    "diabetes",
    "haematuria",
    "vaginalDischarge",
    "pmBleeding",
    "anaemia",
    "idAnaemia",
    "thrombocytosis",
    "elevatedGlucose",
    "imagingEndometrial"
        ],
    validator:validateEndometrial,
    displayAs:"Endometrial Cancer",
    requirements:["Ca125", "U&Es", "FBC", "Random Glucose"],
    specialty:["gynaecology"]
    },

    cervical:{
    path:"cervical",
    symptoms:[
    "abnCervix"
    ],
    validator:validateCervical,
    displayAs:"Cervical Cancer",
    requirements:["Ca125", "U&Es", "FBC", "Random Glucose"],
    specialty:["gynaecology"]
    },

 vulval:{
    path:"vulval",
    symptoms:[
    "vulvalLump"
        ],
    validator:validateVulval,
    displayAs:"Vulval Cancer",
    requirements:["Ca125", "U&Es", "FBC", "Random Glucose"],
    specialty:["gynaecology"]
    },

    vaginal:{
    path:"vaginal",
    symptoms:[
        "vaginalMass"
        ],
    validator:validateVaginal,
    displayAs:"Vaginal Cancer",
    requirements:["Ca125", "U&Es", "FBC", "Random Glucose"],
    specialty:["gynaecology"]
    },

    prostate:{path:"prostate",
    symptoms:[
        "urinaryFrequency",
        "urinaryRetention",
        "haematuria",
        "prProstate",
        "erectileDysfunction",
        "psa"
        ],
    validator:validateProstate,
    displayAs:"Prostate Cancer",
    requirements:[],
    specialty:["urology"]
    },

    bladder:{path:"bladder",
    symptoms:[
        "recUti",
        "haematuria",
        "microHaematuria",
        "freqAndUrgency",
        "wcc"
        ],
    validator:validateBladder,
    displayAs:"Bladder Cancer",
    requirements:[],
    specialty:["urology"]
    },

    
    renal:{path:"renal",
    symptoms:[
        "haematuria"
        ],
    validator:validateRenal,
    displayAs:"Renal Cancer",
    requirements:[],
    specialty:["urology"]
    },

    testicular:{
    path:"testicular",
    symptoms:[
        "testisEnlargement",
        "testisShape",
        "testisOther"
        ],
    validator:validateTesticular,
    displayAs:"Testicular Cancer",
    requirements:[],
    specialty:["urology"]
    },

    penile:{
    path:"penile",
    symptoms:[
        "penileMass",
        "foreskin",
        ],
    validator:validatePenile,
    displayAs:"Penile Cancer",
    requirements:[],
    specialty:["urology"]
    },

   

   
    //skin pathways

    melanoma:{path:"melanoma",
    symptoms:["pigmentedLesion",
            "dermoscopyMelanoma",
            "nodularMelanoma",
            ],
    validator:validateMelanoma,
    displayAs:"Melanoma",
    requirements:[],
    specialty:["dermatology"]
    },

    
    squamous:{path:"squamous",
    symptoms:["squamous"],
    validator:validateSquamous,
    displayAs:"Squamous Cell Carcinoma",
    requirements:[],
    specialty:["dermatology"]
    },

    basal:{path:"basal",
    symptoms:["basal", "basalConcerning"],
    validator:validateBasal,
    displayAs:"Basal Cell Carcinoma",
    requirements:[],
    specialty:["dermatology"]
    },

    // head, neck,CNS

    laryngeal:{path:"laryngeal",
    symptoms:["hoarse", "neckLump"],
    validator:validatelaryngeal,
    displayAs:"Laryngeal cancer",
    requirements:["FBC", "U&Es", "Thyroid function"],
    specialty:["ENT"]
    },

    oral:{path:"oral",
    symptoms:["neckLump", "oralUlcer", "oralLump","oralRedPatch"], 
    validator:validateOral,
    displayAs:"Oral cancer",
    requirements:["FBC", "U&Es", "Thyroid function"],
    specialty:["faciomaxillary surgery"]
    },

    thyroid:{path:"thyroid",
    symptoms:["thyroid"], 
    validator:validateThyroid,
    displayAs:"Thyroid cancer",
    requirements:["FBC", "U&Es", "Thyroid function"],
    specialty:["ENT"]
    },

    cns:{path:"cns",
    symptoms:["cns"], 
    validator:validateCns,
    displayAs:"Brain / CNS Cancer",
    requirements:["U&E","MRI brain", "CT brain (if MRI contraindicated)"],
    specialty:["neurosurgery", "neurology"]
    },

// haematological cancers
leukaemia:{path: "leukaemia",
    symptoms: ["pallor",
    "fatigue",
    "fever",
    "infection",
   "lymphadenopathy",
    "bruising",
    "bleeding",
    "petechiae",
    "hepatosplenomegaly",
    "bonePain"],
    validator:validateLeukaemia,
    displayAs: "Leukaemia",
    requirements:[],
    specialty:["haematology"]
},
    

myeloma:{
    path: "myeloma",
    symptoms: ["esr",
    "hypercalcaemia",
    "bence",
    "electrophoresis",
    "leukopenia",
    "fracture",
    "backPain",
    "bonePain"],
    validator:validateMyeloma,
    displayAs: "Myeloma",
    requirements:[],
    specialty:["haematology"]
    },


    nonHodgkins:
    {path: "nonHodgkins",
    symptoms: ["lymphadenopathy",
    "hepatosplenomegaly",
    "splenomegaly",
    "fever",
    "nightSweats",
    "sob",
    "pruritis",
    "weightLoss"],
    validator:validateNonHodgekins,
    displayAs: "Non-Hodgkin's Lymphoma",
    requirements:[],
    specialty:["haematology"]
    },


    hodgkins:
    {path: "hodgkins",
    symptoms: ["lymphadenopathy",
    "fever",
    "nightSweats",
    "sob",
    "pruritis",
    "weightLoss",
    "alcLnPain"],
    validator:validateHodgekins,
    displayAs: "Hodgkin's Lymphoma",
    requirements:[],
    specialty:["haematology"]
    },

    //sarcoma validators

    boneSarcoma:
    {path: "boneSarcoma",
    symptoms: ["xrBoneSarcoma",
    "bonePain",
    "boneLump",],
    validator:validateBoneSarcoma,
    displayAs: "Bone Sarcoma",
    requirements:[],
    specialty:["orthopaedic surgery"]},

    softTissueSarcoma:
    {path: "softTissueSarcoma",
    symptoms: ["usSarcoma",
    "stLump"],
    validator:validateSoftTissueSarcoma,
    displayAs: "Soft Tissue Sarcoma",
    requirements:[],
    specialty:["orthopaedic surgery"]
    },


    //childhood tumours

    neuroblastoma:
    {path: "neuroblastoma",
    symptoms: ["upperAbdoMass",
        "hepatosplenomegaly",
        "splenomegaly",
        "LiverGbMass",
        "abdoMass",
        "pelvicMass"],
    validator:validateNeuroblastoma,
    displayAs: "Neuroblastoma",
    requirements:[],
    specialty:["paediatrics"]
    },


    retinoblastoma:
    {path: "retinoblastoma",
    symptoms: ["squint", "lossRedReflex"],
    validator:validateRetinoblastoma,
    displayAs: "Retinoblastoma",
    requirements:[],
    specialty:["opthalmology", "paediatrics"]},

    wilms:
    {path: "wilms",
    symptoms: ["upperAbdoMass",
                "hepatosplenomegaly",
                "splenomegaly",
                "LiverGbMass",
                "abdoMass",
                "pelvicMass",
                "haematuria"],
    validator:validateWilms,
    displayAs: "Wilm's Tumour",
    requirements:[],
    specialty:["paediatrics"]
    },


    //non specific

    nonSpecific:{
    path: "nonSpecific",
    symptoms: ["weightLoss", 
    "fatigue",
    "malaise",
    "distension", 
    "dvt", 
    "appetiteLoss",
    "abdoPain",
    "bonePain",
    "nonSpecPain"],
    validator:validateNonSpecific,
    displayAs: "Non-specific symptoms",
    requirements:["Chest X Ray", "FIT tests", "Urine Dipstick and culture", "FBC","U&E", "ESR", "CRP", "Thyroid function", "LFT", "Globulins", "HBA1c", "Bone Profile", "Ferritin", "Iron Studies", "B12", "Folate","(PSA or Ca125)"],
    specialty:["gastroenterology", "general medicine", "orthopaedics", "paediatrics"]
    },



    childConcern:
    {path: "childConcern",
    symptoms: [
    "childConcern",
   ],
    validator:validateChildConcern,
    displayAs: "Concern about a child",
    requirements:[],
    specialty:[ "paediatrics"]
    }

}
export default validatorIndex